import { getId, Modal, Icon } from "@fluentui/react";
import { useRef, useEffect } from "react";
import { StyleUtils } from "../../common/views/StyleUtils";
import { Utils } from "../../common/views/Utils";
import { PopularSearchModel } from "../../websites/models/PopularSearchModel";
import { usePopularSearchVM } from "../viewmodels/PopularSearchVM";
import PopularSearchView from "./PopularSearchView";
import PopularSearchWebsiteView from "./PopularSearchWebsiteView";

export type AllPopularSearchProps = {
    onClose: () => void;
}

export default function AllPopularWebsiteView({ onClose }: AllPopularSearchProps) {
    const hasLoaded = useRef(false);
    const vm = usePopularSearchVM();

    useEffect(() => {
        if (hasLoaded.current) return;

        hasLoaded.current = true;

        vm.getList(0);
    }, [vm]);

    const isMobile = window.innerWidth <= 500;
    const titleId: string = getId('title');
    const subtitleId: string = getId('subText');
    const width6 = Utils.getColumnWidth(6);
    const width12 = Utils.getColumnWidth(12);

    const onSelect = (search: PopularSearchModel) => {
        vm.setSelectedText(search);
        vm.setShowWebsites(true);
    }

    const onCloseWebsite = () => {
        vm.setSelectedText(null);
        vm.setShowWebsites(false);
    }

    const headerView = () => {
        return <div className="popup-header">
            <div className="ms-Grid ml--10 mr--10">
                <div className="ms-Grid-row bold">
                    <div className={width6}>Popular Searches</div>
                    <div className={width6 + " right"}>
                        <Icon iconName="ChromeClose" className="pointer" onClick={onClose} />
                    </div>
                </div>
            </div>
        </div>;
    }

    const actionRow = () => {
        return <div className="ms-Grid-row container pb-10">
            <div className={width12 + " center"}>
                <span className="pl-10">Sort By:</span>
                <span className="pl-10 cursor font-bold" onClick={() => vm.onSort(false)}>
                    Popularity
                </span>
                <span className="pl-15 cursor font-bold" onClick={() => vm.onSort(true)}>
                    Name
                </span>
            </div>
        </div>;
    }

    const mainContent = () => {
        return <>
            <Modal
                titleAriaId={titleId}
                subtitleAriaId={subtitleId}
                isOpen={true}
                onDismiss={onClose}
                isBlocking={false}
                isModeless={false}
                styles={StyleUtils.getModalWidthStyles(800)}
            >
                {headerView()}

                <div id={subtitleId} className={(isMobile ? "mobile-" : "") + "popup-body"}>
                    {actionRow()}
                    <PopularSearchView key={vm.listHash} list={vm.list} onSelect={onSelect} />
                </div>
            </Modal>
        </>;
    }

    return <>
        {mainContent()}

        {vm.showWebsites && vm.selectedText !== null && <>
            <PopularSearchWebsiteView
                key={vm.selectedText.id}
                search={vm.selectedText}
                onClose={onCloseWebsite}
            />
        </>}
    </>;
}